<template lang="pug">
  .component-backoffice-create-note
    NoteForm(@completed="createNote")

</template>

<script>
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice"
  import MaggieHelper from "../../maggieHelper"
  import ModalReveal from "../../components/structure/foundation/ModalReveal";
  import NoteForm from "../../components/backoffice/NoteForm";

  export default {
    name: "CreateNote",
    components: {NoteForm, ModalReveal},
    data() {
      return {
        note: {description: null},
      }
    },
    methods: {
      createNote(obj) {

        this.note.description = obj.description
        this.note.valid_from = obj.valid_from
        this.note.valid_to = obj.valid_to

        KeplerBackofficeSdk.notes.make(this.note, () => {
          MaggieHelper.notification('Note', 'Note created successfully')
          this.$router.push({path: 'assets', name: 'notes-management'})
        })
      }
    },
    computed: {
      isEntityNote() {
        return this.entity && this.entityId
      }
    },
    props: {
      entity: {
        type: String,
        required: false
      },
      entityId: {
        type: Number,
        required: false
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateNote.vue?078cf161